
/* eslint-disable max-len */
import React from 'react';
import { LFC } from '../../../Legacy';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../../popups/Popup';
import { ManageTagsView } from './ManageTagsView';

export const manageTagsPopup = () => ({ ui: ManageTagsPopup });

export const ManageTagsPopup: LFC<PopupProps> = () => {

    return <Popup>
        <Popup.Content>
            <Flexer flex center>
                <ManageTagsView />
            </Flexer>
        </Popup.Content>
    </Popup>;
};
